// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container {
    display: flex;
    margin: 80px 13vw 0 18vw;
    padding-top: 60px;
}

.profile-photo {
    margin-left: 50px;
    height: fit-content;
    padding: 0;
}

.profile-photo .heading {
    font-size: 22px;
    font-weight: 600;
    margin-top: 100px;
    color: #F94892;
}

.profile-photo .img {
    width: 100%;
    z-index: -3;
}

 .about-container .name {
    line-height: 85px;
    position: absolute;
    right: 6.5vw;
    padding-top: 75px;
    width: 110px;
    overflow-wrap: break-word;
    color: #F94892;
    text-transform: uppercase;
    z-index: 0;
    font-size: 100px;
    font-family: 'Intro', sans-serif;
    font-weight: 800;
    text-transform: uppercase;
    background: -webkit-linear-gradient(-86deg, #ffe1a0  5%, #f67280 53%, #F94892 91%);
    -webkit-background-clip: text;
    -webkit-text-stroke: 4px transparent;
    background-clip: text;
    /* color: #2c2c2c; */
    color: black;
}

.about-container .aboutMe-text {
    font-size: 18px;
    font-weight: 200;
    color: #fff;
    height: fit-content;
}

.aboutMe-text span {
    color: #F94892;
}

.about-container .aboutMe-text h3 {
    color: #fff;    
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 20px;
}

.about-container .aboutMe-text .resume {
    color: #F94892;
    border-bottom: 2.5px solid #F94892;
    transition: all 0.3s ease-in-out;
    display: inline-block;
    font-weight: 800;
}

.about-container .aboutMe-text .resume:hover {
    transform: scale(1.05);
}

@media screen and (max-width: 1150px) {
    .about-container .aboutMe-text {
        font-size: 16px;
    }
    .about-container .name {
        font-size: 80px;
        width: 80px;
        line-height: 70px;
        right: 8vw;
    }
}

@media screen and (max-width: 925px) {
    .about-container {
        flex-direction: column;
        align-items: center;
    }

    .heading, .about-container .name {
        display: none;
    }

    .about-container .aboutMe-text {
        text-align: center;
    }

    .img {
        display: none;
        margin-top: 50px;
        max-width: 400px;
    }
}

@media screen and (max-width: 750px) {
    .about-container {
        margin-left: 9vw;
        margin-top: 0;
        padding-top: 70px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutMeStyle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;CAEC;IACG,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,yBAAyB;IACzB,kFAAkF;IAClF,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,gCAAgC;IAChC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,iBAAiB;IACrB;AACJ","sourcesContent":[".about-container {\n    display: flex;\n    margin: 80px 13vw 0 18vw;\n    padding-top: 60px;\n}\n\n.profile-photo {\n    margin-left: 50px;\n    height: fit-content;\n    padding: 0;\n}\n\n.profile-photo .heading {\n    font-size: 22px;\n    font-weight: 600;\n    margin-top: 100px;\n    color: #F94892;\n}\n\n.profile-photo .img {\n    width: 100%;\n    z-index: -3;\n}\n\n .about-container .name {\n    line-height: 85px;\n    position: absolute;\n    right: 6.5vw;\n    padding-top: 75px;\n    width: 110px;\n    overflow-wrap: break-word;\n    color: #F94892;\n    text-transform: uppercase;\n    z-index: 0;\n    font-size: 100px;\n    font-family: 'Intro', sans-serif;\n    font-weight: 800;\n    text-transform: uppercase;\n    background: -webkit-linear-gradient(-86deg, #ffe1a0  5%, #f67280 53%, #F94892 91%);\n    -webkit-background-clip: text;\n    -webkit-text-stroke: 4px transparent;\n    background-clip: text;\n    /* color: #2c2c2c; */\n    color: black;\n}\n\n.about-container .aboutMe-text {\n    font-size: 18px;\n    font-weight: 200;\n    color: #fff;\n    height: fit-content;\n}\n\n.aboutMe-text span {\n    color: #F94892;\n}\n\n.about-container .aboutMe-text h3 {\n    color: #fff;    \n    font-size: 36px;\n    font-weight: 500;\n    margin-bottom: 20px;\n}\n\n.about-container .aboutMe-text .resume {\n    color: #F94892;\n    border-bottom: 2.5px solid #F94892;\n    transition: all 0.3s ease-in-out;\n    display: inline-block;\n    font-weight: 800;\n}\n\n.about-container .aboutMe-text .resume:hover {\n    transform: scale(1.05);\n}\n\n@media screen and (max-width: 1150px) {\n    .about-container .aboutMe-text {\n        font-size: 16px;\n    }\n    .about-container .name {\n        font-size: 80px;\n        width: 80px;\n        line-height: 70px;\n        right: 8vw;\n    }\n}\n\n@media screen and (max-width: 925px) {\n    .about-container {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .heading, .about-container .name {\n        display: none;\n    }\n\n    .about-container .aboutMe-text {\n        text-align: center;\n    }\n\n    .img {\n        display: none;\n        margin-top: 50px;\n        max-width: 400px;\n    }\n}\n\n@media screen and (max-width: 750px) {\n    .about-container {\n        margin-left: 9vw;\n        margin-top: 0;\n        padding-top: 70px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
